import { render, staticRenderFns } from "./TemplateStepsWithIcons.vue?vue&type=template&id=6f5f3f8a&scoped=true&"
import script from "./TemplateStepsWithIcons.vue?vue&type=script&lang=js&"
export * from "./TemplateStepsWithIcons.vue?vue&type=script&lang=js&"
import style0 from "./TemplateStepsWithIcons.vue?vue&type=style&index=0&id=6f5f3f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5f3f8a",
  null
  
)

export default component.exports